import React from 'react'

export default function Payments() {
  return (
    <div>There are no pending payments</div>
  )
}
